import React, { forwardRef } from 'react';
import { getAssetByKey, getIconTone } from './app-assets';
import { useIconSettings } from './IconSettingsProvider';
import { resolveIconSize } from './icon-sizes';

const AssetIcon = forwardRef(function AssetIcon({
  name,
  className = '',
  title,
  ariaHidden = true,
  size = 32,
  customSize,
  style: customStyle,
  color,
  strokeWidth,
  absoluteStrokeWidth,
  ...props
}, ref) {
  const settings = useIconSettings();
  const assetUrl = getAssetByKey(name);

  if (!assetUrl) {
    return null;
  }

  const resolvedSize = resolveIconSize(size, settings, customSize);
  const style = {
    '--wt-asset-icon-size': resolvedSize,
    '--wt-asset-icon-url': `url(${assetUrl})`,
    ...(color ? { color } : {}),
    ...customStyle,
  };

  return (
    <span
      {...props}
      ref={ref}
      data-icon={name}
      data-icon-tone={getIconTone(name)}
      className={className ? `wt-asset-icon ${className}` : 'wt-asset-icon'}
      style={style}
      role={ariaHidden ? undefined : 'img'}
      aria-hidden={props['aria-hidden'] ?? (ariaHidden ? 'true' : undefined)}
      aria-label={!ariaHidden ? title : undefined}
      title={title}
    />
  );
});

export default AssetIcon;
